
import React from 'react';
import { CONTACT_INFO, Icons } from '../constants';

const WhatsAppButton: React.FC = () => {
  return (
    <div className="fixed bottom-8 left-8 z-40 animate-in fade-in slide-in-from-bottom-12 duration-1000">
      <a
        href={`https://wa.me/${CONTACT_INFO.whatsapp}?text=Beste%20Liza,%20ik%20heb%20een%20vraag%20over%20een%20coachingstraject.`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact via WhatsApp"
        className="group relative flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300"
      >
        {/* Pulsating effect */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
        
        <Icons.MessageCircle />
        
        {/* Tooltip */}
        <div className="absolute left-full ml-4 px-4 py-2 bg-white text-gray-800 text-[10px] font-bold uppercase tracking-widest rounded-xl shadow-xl opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-300 whitespace-nowrap border border-accent-light">
          Vraag stellen via WhatsApp
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
